import { Component, OnInit } from '@angular/core';
import { EventEmitter, Output } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ResetPasswordService } from '../../../../core/services/reset-password.service';
import { UiHelperService } from '../../../../services/ui-helper.service';
import { NotificationService } from '../../../../services/notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reset-step-codigo',
  templateUrl: './step-codigo.component.html',
  styleUrls: ['./step-codigo.component.css'],
  standalone: false
})
export class StepCodigoComponent implements OnInit {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  validating = false;
  validateError: string | null = null;
  /** Incrementa al reenviar para que el bloque OTP reinicie el temporizador. */
  resendCount = 0;
  correoOfuscado = '';

  constructor(
    private resetPassword: ResetPasswordService,
    private uiHelper: UiHelperService,
    private notification: NotificationService
  ) {}

  ngOnInit(): void {
    const raw = this.resetPassword.getStorage('datosVerificacion');
    if (raw) {
      try {
        const data = JSON.parse(raw);
        this.correoOfuscado = this.ofuscarCorreo(data.correoElectronico || '');
      } catch (_) {}
    }
  }

  private ofuscarCorreo(correo: string): string {
    if (!correo) return '';
    const [u, d] = correo.split('@');
    if (!d) return '****';
    const uVis = u.length <= 3 ? u.substring(0, 1) + '*'.repeat(Math.max(u.length - 1, 0)) : u.substring(0, 3) + '*'.repeat(u.length - 3);
    const dVis = d.length > 2 ? d.substring(0, 2) + '*'.repeat(d.length - 2) : '**';
    return uVis + '@' + dVis;
  }

  onVerificar(event: { code: string }): void {
    const code = event.code.trim();
    const transactionId = this.resetPassword.getStorage('transactionId');
    if (!transactionId) {
      Swal.fire({ title: 'Error', text: 'Falta la transacción. Vuelve al paso anterior.', icon: 'error', ...this.notification.getSwalBaseConfig() });
      return;
    }
    this.validateError = null;
    this.validating = true;
    this.uiHelper.showSpinner('Validando código de verificación…', 'admin');
    this.resetPassword.validarOtp({ transactionId, codeOtp: code }).pipe(
      finalize(() => {
        this.validating = false;
        this.uiHelper.hideSpinner();
      })
    ).subscribe({
      next: (res) => {
        const ok = res?.successful === true || res?.data?.successful === true;
        if (ok) this.next.emit();
        else this.validateError = 'Código no válido.';
      },
      error: (err) => {
        const msg = err?.error?.mensaje ?? err?.error?.message ?? err?.message ?? 'No se pudo validar el código.';
        this.validateError = typeof msg === 'string' ? msg : 'No se pudo validar el código.';
      }
    });
  }

  onReenviar(): void {
    const raw = this.resetPassword.getStorage('datosVerificacion');
    if (!raw) {
      Swal.fire({ title: 'Error', text: 'Faltan datos. Vuelve al paso anterior.', icon: 'error', ...this.notification.getSwalBaseConfig() });
      return;
    }
    let data: any;
    try { data = JSON.parse(raw); } catch (_) { return; }
    const request = { email: data.correoElectronico, razonSocial: (data.nombres || '') + ' ' + (data.apellidos || '') };
    this.uiHelper.showSpinner('Reenviando código...', 'admin');
    const baseConfig = this.notification.getSwalBaseConfig();
    this.resetPassword.enviarOtp(request).pipe(
      finalize(() => this.uiHelper.hideSpinner())
    ).subscribe({
      next: (res) => {
        if (res?.successful === true && res?.transactionId) {
          this.resetPassword.setStorage('transactionId', res.transactionId);
          this.resendCount++;
          Swal.fire({ title: 'Enviado', text: 'Código reenviado. Revisa tu correo.', icon: 'success', ...baseConfig });
        }
      },
      error: (err) => {
        const msg = err?.error?.mensaje ?? err?.error?.message ?? 'No se pudo reenviar.';
        Swal.fire({
          title: 'Error',
          text: typeof msg === 'string' ? msg : 'No se pudo reenviar.',
          icon: 'error',
          ...this.notification.getSwalBaseConfigReloadAfterClose()
        });
      }
    });
  }
}
